<template>
  <div class="tabs-outfits">
    <div v-if="capsuleOutfits.length === 0">
      <OutfitsEmptyState />
    </div>

    <div v-else class="outfits-grid">
      <outfit
        v-for="outfit in capsuleOutfits"
        :key="outfit.id"
        :outfit="outfit"
      />
    </div>
  </div>
</template>

<script>
import Outfit from "@/components/showCapsule/Outfit";
import OutfitsEmptyState from "@/components/showCapsule/tabs/emptyStates/OutfitsEmptyState";
import { mapGetters } from "vuex";

export default {
  components: {
    Outfit,
    OutfitsEmptyState,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["capsuleOutfits"]),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.tabs-outfits {
  .outfits-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 280px);
    grid-gap: 2.5rem;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/tabs/OutfitsTab.vue